(function ($) {
    "use strict";

    // Opens/closes a .pm-contact-card--popup (see template-parts/partials/
    // pm-contact-card.php). Any element on the page can open it just by
    // carrying the .js-pm-contact-popup-toggle class; an optional
    // data-popup-target="<id>" attribute targets a specific popup instance,
    // otherwise the first .js-pm-contact-popup found on the page is used.
    $(function () {
        $(document).on("click", ".js-pm-contact-popup-toggle", function (e) {
            e.preventDefault();

            var targetId = $(this).data("popup-target");
            var $popup = targetId ? $("#" + targetId) : $(".js-pm-contact-popup");

            $popup.toggleClass("is-open");
        });

        $(document).on("click", ".js-pm-contact-popup-close", function (e) {
            e.preventDefault();

            $(this).closest(".js-pm-contact-popup").removeClass("is-open");
        });
    });
})(jQuery);
